async function updateQuickCart() {
  const response = await fetch(
    `${window.Shopify.routes.root}cart?section_id=main-quick-cart`
  );

  if (!response.ok) return;

  const html = await response.text();

  const doc = new DOMParser().parseFromString(html, 'text/html');

  const newModal = doc.querySelector('#quick-cart-modal');
  const newQuickCart = newModal?.querySelector('.quick-cart');

  if (!newModal || !newQuickCart) return;

  let modal = document.querySelector('#quick-cart-modal');

  if (!modal) {
    document.body.insertAdjacentHTML(
      'beforeend',
      newModal.outerHTML
    );

    modal = document.querySelector('#quick-cart-modal');
  } else {
    const currentQuickCart = modal.querySelector('.quick-cart');

    currentQuickCart?.replaceWith(newQuickCart);
  }

  return modal;
}

document.addEventListener('click', async (event) => {
  const trigger = event.target.closest('[data-quick-cart-trigger]');

  if (!trigger) return;

  event.preventDefault();

  const modal = await updateQuickCart();

  if (!modal) return;

  modal.classList.remove('unreveal');
  modal.classList.add('reveal');

  document.body.classList.add('modal-active');
});

function initClick(el) {
  if (el.__initClick) return;
  el.__initClick = true;

  el.addEventListener('click', function (event) {
    const currentTrigger = event.target.closest('.custom-click-trigger');

    // 确保点击的是当前 custom-click 容器内的 trigger
    if (!currentTrigger || !el.contains(currentTrigger)) return;

    const currentId = currentTrigger.dataset.id;
    if (!currentId) return;

    // CSS.escape 防止 ID 中存在特殊字符
    const currentTarget = el.querySelector(
      `.custom-click-target#${CSS.escape(currentId)}`
    );

    if (!currentTarget) return;

    // 是否允许重复点击切换
    const canToggle = currentTrigger.hasAttribute('data-toggle');

    // 当前是否已经激活
    const isActive =
      currentTrigger.classList.contains('active') &&
      currentTarget.classList.contains('active');

    // 没有 data-toggle，且已经激活，再次点击不执行任何操作
    if (!canToggle && isActive) return;

    // 有 data-toggle 时，重复点击切换 active
    const shouldActivate = canToggle ? !isActive : true;

    if (canToggle) {
      /*
       * toggle 模式：
       * 当前项可以展开和收起。
       * 其他项仍然移除 active。
       */
      el.querySelectorAll('.custom-click-trigger').forEach(function (trigger) {
        trigger.classList.toggle(
          'active',
          shouldActivate && trigger === currentTrigger
        );
      });

      el.querySelectorAll('.custom-click-target').forEach(function (target) {
        const isCurrentTarget = target === currentTarget;

        target.classList.toggle(
          'active',
          shouldActivate && isCurrentTarget
        );

        // 其他 target 恢复收起高度
        if (!isCurrentTarget) {
          setCollapsedHeight(target);
        }
      });
    } else {
      /*
       * 普通模式：
       * 当前项添加 active，其他项移除 active。
       */
      el.querySelectorAll('.custom-click-trigger').forEach(function (trigger) {
        trigger.classList.toggle('active', trigger === currentTrigger);
      });

      el.querySelectorAll('.custom-click-target').forEach(function (target) {
        const isCurrentTarget = target === currentTarget;

        target.classList.toggle('active', isCurrentTarget);

        if (!isCurrentTarget) {
          setCollapsedHeight(target);
        }
      });
    }

    if (shouldActivate) {
      setExpandedHeight(currentTarget);
    } else {
      setCollapsedHeight(currentTarget, currentTrigger);
    }
  });

  /**
   * 展开时，将内容真实高度写入 --m-h
   */
  function setExpandedHeight(target) {
    // 优先查找指定的内容元素
    const content =
      target.querySelector('[data-height-content]') ||
      target.firstElementChild;

    if (!content) return;

    /*
     * scrollHeight 可以获得元素完整内容高度，
     * 包括当前被 max-height 隐藏的部分。
     */
    const contentHeight = content.scrollHeight;

    target.style.setProperty('--m-h', `${contentHeight}px`);

    /*
     * 图片或异步内容可能在点击后改变高度，
     * 下一帧再计算一次会更准确。
     */
    requestAnimationFrame(function () {
      target.style.setProperty('--m-h', `${content.scrollHeight}px`);
    });
  }

  /**
   * 收起时，将 --m-h 恢复为 data-height
   */
  function setCollapsedHeight(target, trigger) {
    const height =
      target.dataset.height ||
      trigger?.dataset.height;

    if (height === undefined || height === '') return;

    target.style.setProperty('--m-h', normalizeHeight(height));
  }

  /**
   * data-height="200" 自动转换成 200px；
   * data-height="10rem"、"50vh" 等单位保持不变。
   */
  function normalizeHeight(height) {
    const value = String(height).trim();

    return /^-?\d+(\.\d+)?$/.test(value)
      ? `${value}px`
      : value;
  }
}

const watchList = [
  {
    selector: '.custom-click',
    handler: initClick,
    flag: '__initClick'
  }
];

// 初次加载
watchList.forEach(item => {
  document.querySelectorAll(item.selector).forEach(node => {
    if (item.flag && node[item.flag]) return;
    item.handler(node);
  });
});

// 统一 MutationObserver 监听
let moTimer = null;

const observer = new MutationObserver(() => {
  clearTimeout(moTimer);
  moTimer = setTimeout(() => {
    watchList.forEach(item => {
      document.querySelectorAll(item.selector).forEach(node => {
        if (item.flag && node[item.flag]) return;
        item.handler(node);
      });
    });
  }, 50);
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});

document.addEventListener('DOMContentLoaded', function () {
  /* =====================================================
      页面 Hover Video
  ===================================================== */
  const pageVideoItems = document.querySelectorAll('.hover-video .hover-video-item');

  function resetPageVideoItem(item) {
    const video = item.querySelector('.card-video');
    const image = item.querySelector('.rimage-wrapper img');
    const icon = item.querySelector('.hover-video-icon');
    if (video) {
      video.pause();
      video.classList.add('hidden');
    }
    if (image) image.classList.remove('hidden');
    if (icon) icon.classList.remove('hidden');
  }

  function pausePageVideos() {
    pageVideoItems.forEach(function (item) {
      resetPageVideoItem(item);
    });
  }

  pageVideoItems.forEach(function (item) {
    const inner = item.querySelector('.hover-video-inner');
    const video = item.querySelector('.card-video');
    const image = item.querySelector('.rimage-wrapper img');
    const icon = item.querySelector('.hover-video-icon');
    if (!inner || !video) return;

    /* Mouse Enter */
    inner.addEventListener('mouseenter', function () {
      const modal = document.getElementById('modal-video-modal');
      if (modal && modal.classList.contains('reveal')) return;

      pageVideoItems.forEach(function (otherItem) {
        if (otherItem !== item) resetPageVideoItem(otherItem);
      });

      // 第一次 Hover 才加载视频
      if (!video.getAttribute('src')) {
        const src = video.dataset.src;
        if (!src) return;
        video.src = src;
      }

      if (image) image.classList.add('hidden');
      if (icon) icon.classList.add('hidden');
      video.classList.remove('hidden');
      video.play().catch(function () { });
    });

    /* Mouse Leave：暂停并保留最后一帧 */
    inner.addEventListener('mouseleave', function () {
      video.pause();
      if (icon) icon.classList.remove('hidden');
    });
  });

  /* =====================================================
      Modal
  ===================================================== */
  const modal = document.getElementById('modal-video-modal');
  if (!modal) return;

  // Modal 移动到 body
  if (modal.parentElement !== document.body) {
    document.body.appendChild(modal);
  }

  const modalSwiperEl = modal.querySelector('.modal-video.swiper-container');
  if (!modalSwiperEl) return;

  const modalVideos = modal.querySelectorAll('.modal-video-item .card-video');
  const soundButtons = modal.querySelectorAll('.modal-video-sound');
  let modalSwiper = null;
  let modalVideosLoaded = false;

  /* =====================================================
     Modal Video Sound
  ===================================================== */
  modal.querySelectorAll('.modal-video-inner').forEach(function (inner) {
    const video = inner.querySelector('.card-video');
    const muteBtn = inner.querySelector('.modal-video-sound.mute');
    const playBtn = inner.querySelector('.modal-video-sound.play');

    if (!video || !muteBtn || !playBtn) {
      return;
    }

    muteBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      video.muted = false;
      muteBtn.classList.remove('active');
      playBtn.classList.add('active');
    });


    playBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      video.muted = true;
      playBtn.classList.remove('active');
      muteBtn.classList.add('active')
    });
  });

  /* =====================================================
      Modal Video 加载
  ===================================================== */
  function loadModalVideos() {
    if (modalVideosLoaded) return;
    modalVideos.forEach(function (video) {
      const src = video.dataset.src;
      if (src && !video.getAttribute('src')) video.src = src;
    });
    modalVideosLoaded = true;
  }

  function pauseModalVideos() {
    modalVideos.forEach(function (video) {
      video.pause();
    });
  }

  function resetModalSound(){
    modal.querySelectorAll('.modal-video-inner').forEach(function(inner){
      const video = inner.querySelector('.card-video');
      const muteBtn = inner.querySelector('.modal-video-sound.mute');
      const playBtn = inner.querySelector('.modal-video-sound.play');

      if(video){
        video.muted = true;
      }

      if(muteBtn){
        muteBtn.classList.add('active');
      }

      if(playBtn){
        playBtn.classList.remove('active');
      }
    });
  }

  /* =====================================================
      获取 Modal Swiper
  ===================================================== */
  function getModalSwiper() {
    if (modalSwiperEl.swiper) {
      modalSwiper = modalSwiperEl.swiper;
      return modalSwiper;
    }

    if (modalSwiper) return modalSwiper;

    if (typeof Swiper !== 'undefined') {
      modalSwiper = new Swiper(modalSwiperEl, {
        slidesPerView: 1,
        navigation: {
          nextEl: modal.querySelector('.swiper-button-next'),
          prevEl: modal.querySelector('.swiper-button-prev')
        }
      });
    }

    return modalSwiper;
  }

  /* =====================================================
      播放当前 Modal Video
  ===================================================== */
  function playActiveModalVideo() {
    const swiper = getModalSwiper();
    if (!swiper) return;

    pauseModalVideos();

    const activeSlide = swiper.slides[swiper.activeIndex];
    if (!activeSlide) return;

    const video = activeSlide.querySelector('.card-video');
    if (!video) return;

    // 保险：如果当前视频还没有 src
    if (!video.getAttribute('src')) {
      const src = video.dataset.src;
      if (src) video.src = src;
    }

    video.muted = true;

    video.play().catch(function () { });
  }

  /* =====================================================
      Modal Swiper Events
  ===================================================== */
  function initModalSwiperEvents() {
    const swiper = getModalSwiper();
    if (!swiper || swiper.__videoEvents) return;

    swiper.__videoEvents = true;

    swiper.on('slideChange', function () {
      pauseModalVideos();
      resetModalSound();
      requestAnimationFrame(function () {
        playActiveModalVideo();
      });
    });

    swiper.on('transitionEnd', function () {
      playActiveModalVideo();
    });
  }

  /* =====================================================
      打开 Modal
  ===================================================== */
  function openModal(index) {
    // 暂停页面视频
    pausePageVideos();

    // 第一次打开时移除 display:none
    modal.style.removeProperty('display');
    if (!modal.getAttribute('style')) modal.removeAttribute('style');

    // 显示 Modal
    modal.classList.add('reveal');
    document.body.classList.add('modal-active');

    // 第一次打开统一给 Modal Video 添加 src
    loadModalVideos();

    // 等待 Modal 完成 layout 后再处理 Swiper
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        const swiper = getModalSwiper();
        if (!swiper) return;

        initModalSwiperEvents();
        swiper.update();

        swiper.allowTouchMove = false;

        if (swiper.params) {
          swiper.params.onlyExternal = true;
        }

        // 定位到对应视频，不触发 callback
        swiper.slideTo(index, 0, false);

        if (typeof swiper.updateClasses === 'function') {
          swiper.updateClasses();
        }

        requestAnimationFrame(function () {
          playActiveModalVideo();
        });
      });
    });
  }

  /* =====================================================
      点击页面视频打开 Modal
  ===================================================== */
  pageVideoItems.forEach(function (item) {
    item.addEventListener('click', function () {
      const swiperEl = this.closest('.swiper-container');
      const pageSwiper = swiperEl ? swiperEl.swiper : null;

      // Swiper 拖动时不触发点击
      if (pageSwiper && pageSwiper.allowClick === false) return;

      const index = Number(this.dataset.loopIndex) - 1;
      if (Number.isNaN(index) || index < 0) return;

      openModal(index);
    });
  });

  /* =====================================================
      Modal 关闭监听
      主题负责移除 reveal
  ===================================================== */
  const observer = new MutationObserver(function () {
    if (!modal.classList.contains('reveal')) {
      pauseModalVideos();
      resetModalSound();
    }
  });

  observer.observe(modal, {
    attributes: true,
    attributeFilter: ['class']
  });

  /* =====================================================
      Modal Products 鼠标横向拖动
  ===================================================== */
  const productScrollers = modal.querySelectorAll('.modal-video-pr');

  productScrollers.forEach(function (slider) {
    let isDown = false;
    let startX = 0;
    let startScrollLeft = 0;
    let hasMoved = false;

    slider.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      isDown = true;
      hasMoved = false;
      startX = e.clientX;
      startScrollLeft = slider.scrollLeft;
      slider.classList.add('is-dragging');

      e.preventDefault();

      e.stopPropagation();
    });

    document.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      const distance =
        e.clientX - startX;

      if (Math.abs(distance) > 1) {
        hasMoved = true;
      }

      slider.scrollLeft =
        startScrollLeft - distance * 1.5;
    });

    document.addEventListener('mouseup', function () {
      if (!isDown) return;

      isDown = false;

      slider.classList.remove(
        'is-dragging'
      );
    });

    slider.addEventListener('click', function (e) {
      if (hasMoved) {
        e.preventDefault();

        e.stopPropagation();

        hasMoved = false;
      }
    }, true);
  });
});